// @flow
import client from '../../client'
import format from '../../utils/format'
import jwt from '../../utils/jwt'

// API Endpoints
export const USER_CHANGE_PASSWORD = '/auth/users/{0}/change_password/'

/**
 * Changes the current user's password.
 * @param  {Object} data User password information.
 * @param  {string} data.password The user's current password.
 * @param  {string} data.new_password The new password.
 * @param  {string} data.new_password_confirm The new password's confirmation.
 * @return {Promise|Error} A resolved Promise with the boolean response whether the password
 *                           change was successful or Rejected with an Error
 */
export const changePassword = (data: {
  password: string,
  newPassword: string,
  newPasswordConfirmation: string,
}): Promise<any> => {
  const { password, newPassword, newPasswordConfirmation } = data

  if (newPassword !== newPasswordConfirmation) {
    return Promise.resolve(false)
  }

  const userId = jwt.getAuthorizedUserId()
  const endpoint = format(USER_CHANGE_PASSWORD, userId)

  const options = {
    body: {
      password: newPassword,
      old_password: password,
    },
  }

  return client.post(endpoint, options).then((response) => response.success)
}

export default changePassword
